
<!-- MEASUREMENT TYPE - MATURITY -->

<!-- MEASUREMENT INFORMATION CARD -->
@if (measurement(); as m) {
  <cosmos-measurement-info-card
    [measurement]="m"
    [device]="device()"
    [concrete]="concrete()"
    [cardSubtitle]="('measurement.types.MaturityMeasurement' | translate) + ' - ' + ((m.active ? 'measurement.ongoing' : 'measurement.finished') | translate)"
  >
    <ng-container cardFooter>
      <p-confirmdialog />
      <div class="flex flex-wrap gap-2 items-center">
        @if (rbac.canEditProject()) {
          <p-button (click)="editMeasurement()" color="primary"><i class="fa-solid fa-edit"></i> {{ "measurement.edit" | translate }}</p-button>
        }
        @if (m.active && rbac.canEditProject()) {
          <div id="onboarding-measurement-finish">
            <p-button (click)="finishMeasurement($event)" severity="danger"><i class="fa-solid fa-link-slash"></i>{{ "measurement.finish" | translate }}</p-button>
          </div>
        }
        @if (m.active && rbac.canEditProject()) {
          <div id="onboarding-measurement-change-device">
            <p-button (click)="changeDevice(m)" severity="secondary"><i class="fa-solid fa-shuffle"></i>{{ "measurement.change_device" | translate }}</p-button>
          </div>
        }
        @if (rbac.canEditProject()) {
          <div id="onboarding-measurement-actions-menu">
            <cosmos-measurement-actions-menu [actions]="tier2Actions()" />
          </div>
        }
      </div>
    </ng-container>
  </cosmos-measurement-info-card>
}

<p-divider></p-divider>

<!--CHARTS-->
@if (measurement(); as m) {
  <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
    <cosmos-strength-insights-card
        id="onboarding-strength-insights"
        [config]="m.project"
        [currentStrength]="m.strength?.length ? m.strength[m.strength.length - 1] : 0"
        [currentMaturity]="m.maturity?.length ? m.maturity[m.maturity.length - 1] : 0"
        [currentRelativeMaturity]="$any(m).relativeMaturity?.length ? $any(m).relativeMaturity[$any(m).relativeMaturity.length - 1] : 0"
        [specifications]="m.specifications"
        [specifications_maturity]="m.specifications_maturity"
        [specifications_relative_maturity]="m.specifications_maturity_relative"
        [currentTime]="m.time?.length ? m.time[m.time.length - 1] : undefined"
        >
    </cosmos-strength-insights-card>
    <!-- right side -->
    <div class="col-span-2 grid gap-4 min-w-0">
      <p-card id="onboarding-maturity-chart" class="min-w-0">
        <ng-template #title>{{ "measurement.chart.title" | translate }}</ng-template>
        <ng-template #subtitle>{{ "measurement.chart.subtitle" | translate }}</ng-template>
        <!-- content -->
        <cosmos-dynamic-line-chart
          [dataObject]="m"
          [datasets]="['temperature', 'strength']"
          [labels]="['temperature', 'strength']"
          [thresholds]="strengthChartThreshold()"
          [chartId]="'maturity_temp_strength'"
          (datapointClick)="onDatapointClick($event)">
        </cosmos-dynamic-line-chart>
      </p-card>

      <!-- MATURITY -->
      @if (maturityChartFields().length > 0) {
        <p-card id="onboarding-maturity-maturity-chart" class="min-w-0">
          <ng-template #title>{{ "measurement.maturity-chart.title" | translate }}</ng-template>
          <ng-template #subtitle>{{ "measurement.maturity-chart.subtitle" | translate }}</ng-template>
          <!-- content -->
          <cosmos-dynamic-line-chart
            [dataObject]="m"
            [datasets]="maturityChartFields()"
            [labels]="maturityChartFields()"
            [thresholds]="maturityChartThreshold()"
            [chartId]="'maturity_maturity'"
            (datapointClick)="onDatapointClick($event)">
          </cosmos-dynamic-line-chart>
        </p-card>
      }
      <!-- PREDICTIVE -->
      @if (entitlementService.hasFeature('monitoring', 'monitoring.charts.strength_prediction') && predictions()) {
        <p-card id="onboarding-predictive-chart" class="min-w-0">
          <ng-template #title>{{ "measurement.predictive-chart.title" | translate }}</ng-template>
          <ng-template #subtitle>{{ "measurement.predictive-chart.subtitle" | translate }}</ng-template>
          <!-- content -->
          <cosmos-predictive-chart [realData]="m" [predictionData]="predictions()" [chartId]="'maturity_predictive'"></cosmos-predictive-chart>
        </p-card>
      }
    </div>

  </div>
}
